import { ToastProvider } from '@jaymathew/ui-shared/contexts/ToastContext'
import { Loading } from '@jaymathew/ui-shared/elements/Loading'
import { Suspense } from 'react'
import { Provider } from 'react-redux'
import { Outlet } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import { persistor, store } from 'redux/store'
import LocalThemeWrapper from 'resources/localThemeWrapper'
import ScrollToTop from './ScrollToTop'
import ThemeSync from 'resources/ThemeSync'

const RouteWrapper = () => (
	<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
			<LocalThemeWrapper>
				<ThemeSync />
				<ToastProvider>
					<ScrollToTop>
						<Suspense fallback={<Loading />}>
							<Outlet />
						</Suspense>
					</ScrollToTop>
				</ToastProvider>
			</LocalThemeWrapper>
		</PersistGate>
	</Provider>
)

export default RouteWrapper
